// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BottomPopup__container-c96aef {
  padding: 24px;
  border: 1px solid var(--base-30);
  border-radius: 8px;
  background: var(--color-background-base);
  box-shadow: var(--box-shadow-popover);
  position: fixed;
  inset-inline-end: 24px;
  bottom: 72px;
}

.BottomPopup__close-f549c2 {
  position: absolute;
  top: 20px;
  inset-inline-end: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/BottomPopup/BottomPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,qCAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,sBAAA;AACF","sourcesContent":[".container {\n  padding: 24px;\n  border: 1px solid var(--base-30);\n  border-radius: 8px;\n  background: var(--color-background-base);\n  box-shadow: var(--box-shadow-popover);\n  position: fixed;\n  inset-inline-end: 24px;\n  bottom: 72px;\n}\n\n.close {\n  position: absolute;\n  top: 20px;\n  inset-inline-end: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BottomPopup__container-c96aef`,
	"close": `BottomPopup__close-f549c2`
};
module.exports = ___CSS_LOADER_EXPORT___;
